import { makeStyles } from 'tss-react/mui';

import { isLightTheme } from 'uiKit/Theme/themeUtils';

const name = 'BillingTab';

export const useBillingTabStyles = makeStyles({ name })(theme => ({
  root: {
    padding: 0,
    paddingBottom: theme.spacing(5),
    minWidth: 'unset',

    '&:hover': {
      color: theme.palette.text.secondary,
    },
  },
  selected: {
    '&:hover': {
      color: isLightTheme(theme)
        ? theme.palette.primary.main
        : theme.palette.primary.dark,
    },
  },
}));
